export const BUG_ID = 1

export const TESTER_ROLE_ID = 2

export const LEXICAL_EMPTY_PARAGRAPH_HTML =
  '<p class="editor-paragraph"><br></p>'
